import { type CategoriaDTO } from '@framework/api-client/api/inquiries/schemas/categoriaDTO.ts';
import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InquiryItemDivider } from './InquiryItemDivider.tsx';

const StyledTagBold = styled(Tag)`
  &&& {
    font-weight: 600;
  }
`;

export interface IInquiryCategoryRenderProps {
  categories?: CategoriaDTO[] | null;
}

export function InquiryCategoryRender(props: IInquiryCategoryRenderProps) {
  const { categories } = props;
  const { t } = useTranslation();
  if (!categories || categories.length == 0) return null;

  return (
    <div>
      <div> {t('domanda.copertina.categorie', 'Categorie')}:</div>
      {categories?.map(category => (
        <Tooltip key={category.id} title={category.descrizione}>
          <StyledTagBold>{category.etichetta}</StyledTagBold>
        </Tooltip>
      ))}
      <InquiryItemDivider />
    </div>
  );
}
